import type { SubVerticalCrTopicPageQuery } from '../../../generated/frontend'
import { useBackStack } from '../../../shared/BrowserBackStackProvider'
import { getDataLayerScripts } from '../../../shared/data-layer'
import { getDFPScripts } from '../../../shared/dfp'
import { useFullUrl } from '../../../shared/hooks/useFullUrl'
import type { PageInfo } from '../../../shared/types/PageInfo'
import { getPreviousUrl } from '../../../shared/utils/getPreviousUrl/getPreviousUrl'
import { removeFalsy } from '../../../shared/utils/remove-falsy'
import { removeUrlQueryStringAndFragment } from '../../../shared/utils/remove-url-query-string-and-fragment'
import { useSubVerticalPageDataLayer } from './useSubVerticalPageDataLayer'

export const useSubVerticalDataLayer = () => {
  const { getPageDatalayer } = useSubVerticalPageDataLayer()
  const { getFullUrl } = useFullUrl()
  const backStack = useBackStack()
  const previousUrl = getPreviousUrl({ backStack: backStack })

  return {
    getDataLayerItems(meta: SubVerticalCrTopicPageQuery['subVerticalPage']['meta']) {
      const { dataLayer = [], taxonomyHierarchy } = meta || {}

      const pageInfo: PageInfo = {
        wcdPageUrl: removeUrlQueryStringAndFragment(getFullUrl()),
        vertical: taxonomyHierarchy?.vertical.slug,
        sub_vertical: taxonomyHierarchy?.subVertical?.slug,
        super_category: (taxonomyHierarchy as any)?.superCategory?.slug,
        category: (taxonomyHierarchy as any)?.category?.slug,
        content_type: 'sub-vertical',
        ...(previousUrl && { previousWcdPageUrl: previousUrl }),
      }
      const mappedPageInfo = removeFalsy(getPageDatalayer(pageInfo))

      return [
        ...getDataLayerScripts([...dataLayer, mappedPageInfo]),
        ...getDFPScripts(dataLayer, mappedPageInfo),
      ]
    },
  }
}
